export default __webpack_public_path__ + "static/media/5.136aa9a8.png";